import styled from "styled-components";

export const FooterButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 480px) {
    flex-direction: row;
    gap: 8px;
  }
`;

export const SecondaryActionButton = styled.button`
  height: 44px;
  padding: 0 20px;
  border-radius: 10px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border: 1px solid ${({ variant }) =>
        variant === "danger" ? "#E71037" : "#d9d9d9"};

  background: ${({ variant }) =>
        variant === "danger" ? "#E71037" : "#fff"};

  color: ${({ variant }) =>
        variant === "danger" ? "#fff" : "#1f1f1f"};

  font-size: 14px;
  font-weight: 600;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg, img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    display: block;
  }
`;